import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onCancel: () => void;
};

const UnarchiveDeclarationModal = ({ open, onCancel, onConfirm }: Props) => {
    return (
        <ConfirmationModal
            width={440}
            open={open}
            onConfirm={onConfirm}
            onCancel={onCancel}
            icon={<ContainerOutlined />}
            title="Unarchive Declaration?"
            confirmButtonText="Unarchive"
            content={<Typography.Text>The declarations will be unarchived and become active.</Typography.Text>}
        />
    );
};

export default UnarchiveDeclarationModal;
